import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isStringCSV = ({
  fieldValue,
}) => ({
  hasError: !/^[a-zA-Z0-9\s\-_]+(,\s*[a-zA-Z0-9\s\-_]+)*$/.test(fieldValue),
  error: i18n.t('error-not-csv-string'),
});

registerValidator('isStringCSV', isStringCSV);

export default isStringCSV;
